export default __webpack_public_path__ + "static/refund-monnify-dashboard-883c8db5e2dda7f5000b49b63c8ae380.png";